import {BranchState} from './BranchState';

type WorkroundRootState = Record<string, any> & {
  branch: BranchState;
};

export const selectActiveBranchId = ({branch}: WorkroundRootState) => branch?.activeBranchId;
export const selectDefaultBranchId = ({branch}: WorkroundRootState) => branch.defaultBranchId;
export const selectUserBranchOptions = ({branch}: WorkroundRootState) => branch.userOptions;
